import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { FEDERAL_WITHHOLDING_OPTIONS, ISS_OPTIONS, ISS_TAXATION_MAP, PIS_COFINS_OPTIONS } from "../../../../helpers/nfseHelpers";
import ibsData from "../../../../data/static/lista_ibs_cbs.json";
import TooltipIssInfo from "./TooltipIssInfo";

const issIncidenceCity = (value) => ({
    company_city: 'Endereço da empresa',
    customer_city: 'Endereço do cliente',
}[value] || '-');

const getLabelByValue = (options, value) => {
    return options.find(opt => opt.value === value)?.label || '-';
};

const ibsOptions = ibsData.map(item => ({
    value: item.code,
    label: item.description
}));

const FiscalInfosTable = ({ fiscalData }) => {
    const ISSValue = ISS_TAXATION_MAP[fiscalData?.iss_taxation_type];
    return (
        <Table
            sx={{
                width: '100%',
                tableLayout: 'fixed',
                '& .MuiTableCell-root': {
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    padding: '0.375rem 1rem',
                },
                '& .MuiTableHead-root .MuiTableCell-root': {
                    padding: '0.375rem 1rem',
                }
            }}
        >
            <TableHead>
                <TableRow>
                    <TableCell sx={{ width: '75%' }}>
                        <Typography><b> Descrição </b></Typography>
                    </TableCell>
                    <TableCell sx={{ width: '25%' }}>
                        <Typography fontWeight="bold"><b>Alíquota</b></Typography>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell sx={{ width: '75%' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                            <Box>
                                <Typography variant="body2"> ISS </Typography>
                            </Box>
                            <Box>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">
                                        Cidade de incidência: {issIncidenceCity(fiscalData?.iss_incidence_city)}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">
                                        Tipo: {ISSValue} - {getLabelByValue(ISS_OPTIONS, ISSValue)}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </TableCell>
                    <TableCell sx={{ width: '25%' }}>
                        <Typography variant="body2">
                            {fiscalData?.iss_rate ? (
                                fiscalData.iss_rate
                            ) : (
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography variant="body2">Padrão</Typography>
                                    <TooltipIssInfo />
                                </Box>
                            )}
                        </Typography>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell sx={{ width: '75%' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                            <Box>
                                <Typography variant="body2"> Retenção PIS, COFINS e CSLL</Typography>
                            </Box>
                            <Box>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">
                                        CST: {fiscalData?.pis_cofins_tax_situation_code} - {getLabelByValue(PIS_COFINS_OPTIONS, fiscalData?.pis_cofins_tax_situation_code)}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">
                                        Tipo: {fiscalData?.pis_cofins_retention_code} - {getLabelByValue(FEDERAL_WITHHOLDING_OPTIONS, fiscalData?.pis_cofins_retention_code)}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </TableCell>
                    <TableCell sx={{ width: '25%' }}>
                        {fiscalData?.pis_retention_rate ||
                            fiscalData?.cofins_retention_rate ||
                            fiscalData?.csll_retention_rate ? (
                            <>
                                <Typography variant="body2"> {fiscalData?.pis_retention_rate ? `${fiscalData.pis_retention_rate}% (PIS)` : ''}</Typography>
                                <Typography variant="body2">{fiscalData?.cofins_retention_rate ? `${fiscalData.cofins_retention_rate}% (COF)` : ''}</Typography>
                                <Typography variant="body2">{fiscalData?.csll_retention_rate ? `${fiscalData.csll_retention_rate}% (CSLL)` : ''}</Typography>
                            </>
                        ) : (
                            <Typography variant="body2">-</Typography>
                        )}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell sx={{ width: '75%' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="body2"> Outras retenções </Typography>
                        </Box>
                    </TableCell>
                    <TableCell sx={{ width: '25%' }}>
                        {fiscalData?.inss_retention_rate ||
                            fiscalData?.irrf_retention_rate ||
                            fiscalData?.cpp_retention_rate ? (
                            <>
                                <Typography variant="body2">{fiscalData?.inss_retention_rate ? `${fiscalData.inss_retention_rate}% (INSS)` : ''}</Typography>
                                <Typography variant="body2">{fiscalData?.irrf_retention_rate ? `${fiscalData.irrf_retention_rate}% (IRRF)` : ''}</Typography>
                                <Typography variant="body2">{fiscalData?.cpp_retention_rate ? `${fiscalData.cpp_retention_rate}% (CPP)` : ''}</Typography>
                            </>
                        ) : (
                            <Typography variant="body2">-</Typography>
                        )}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell sx={{ width: '75%' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                            <Box>
                                <Typography variant="body2"> Reforma Tributária </Typography>
                            </Box>
                            <Box>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">
                                        Adesão Antecipada: {fiscalData?.tax_reform_adhesion === true ? 'Sim' : 'Não'}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">
                                        {fiscalData?.ibs_cbs_operation_indicator ? `Operação: ${fiscalData.ibs_cbs_operation_indicator} 
                                            - ${getLabelByValue(ibsOptions, fiscalData?.ibs_cbs_operation_indicator)}` : '-'}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </TableCell>
                    <TableCell sx={{ width: '25%' }}>
                        {fiscalData?.ibs_municipal_rate ||
                            fiscalData?.ibs_state_rate ||
                            fiscalData?.cbs_rate
                            ? (
                                <>
                                    <Typography variant="body2">{fiscalData?.ibs_municipal_rate ? `${fiscalData.ibs_municipal_rate}% (IBS-M)` : ''}</Typography>
                                    <Typography variant="body2">{fiscalData?.ibs_state_rate ? `${fiscalData.ibs_state_rate}% (IBS-E)` : ''}</Typography>
                                    <Typography variant="body2">{fiscalData?.cbs_rate ? `${fiscalData.cbs_rate}% (CBS)` : ''}</Typography>
                                </>
                            ) : (
                                <Typography variant="body2">-</Typography>
                            )}
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};

export default FiscalInfosTable;